/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import BaseComponent from '../../../../panther/components/base/BaseComponent';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MicrositeSectionTitle from './MicrositeSectionTitle/MicrositeSectionTitle';

import styles from './MicrositeSection.css';

class MicrositeSection extends BaseComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let classes = classNames(
            'container-fluid microsite-section', {
                'background-light': (this.props.colorTheme === "light"),
                'background-colored': (this.props.colorTheme === "colored"),
                'highlighted': this.props.highlighted,
                'text-centered': this.props.textCentered,
            },
            this.props.className
        );

        let title = this.renderTitle();
        let content = this.props.content;
        let headline = null;
        if (this.props.highlighted){
            headline = (
                <div className="section-headline">
                    <div className="section-headline-overlay">
                    </div>
                </div>
            );
        }

        return (
            <section id={this.props.id} className={classes}>
                {headline}
                {title}
                {content}
            </section>
        );
    }

    renderTitle(){
        let light = false;
        if (this.props.colorTheme === 'colored' || this.props.highlighted){
            light = true;
        }

        return (
            <MicrositeSectionTitle
              light={light}
              centered
              divider
              name={this.props.name}
            />
        );
    }
}

MicrositeSection.propTypes = {
    id: PropTypes.string,
    highlighted: PropTypes.bool,
    name: PropTypes.string,
    colorTheme: PropTypes.string,
    textCentered: PropTypes.bool,
};

export default MicrositeSection;